import {makeThemeProps} from "src/themes/utils/utils";

export default (theme, site, options = {}) => {
  const themeStyles = makeThemeProps(theme, site, options);
  return themeStyles.getCategoryBarProps(theme, options);
};
